module.exports = __webpack_public_path__ + "images/emoji/apple.673f3bc7e2c148f3e050.png";